module.exports = "/assets/data/cacb019cb84d31e9b2c452993fdd31e0-SA6.data.json";